// İSG uzmanı portalı — Kontrol aşaması (DepartmentReview) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (Kontrol uçları `[ModuleAction("permits", …)]` + departman-rol kapısı;
// api-contract §31 / brief 095 §3); bu kapı yalnız UX'tir: erişim sondasının
// (useDepartmentReviewAccess) sonucuna göre Kontrol alt-ağacını (Outlet: kuyruk + detay), 403
// sayfasını veya "kullanılamıyor" durumunu gösterir. İş İzni / Ayarlar kapılarıyla aynı desen;
// **backend §31 develop'a henüz merge olmamışsa** prob 404 → "kullanılamıyor" (retry) görünür.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { ClipboardList, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useDepartmentReviewAccess } from '../../lib/departmentReviewAccess';

export function DepartmentReviewGate() {
  const { t } = useTranslation();
  const access = useDepartmentReviewAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('departmentReview.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <ClipboardList className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">
                {t('departmentReview.forbidden.title')}
              </h1>
              <p className="text-sm text-muted">{t('departmentReview.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('departmentReview.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">
                {t('departmentReview.unavailable.title')}
              </h1>
              <p className="text-sm text-muted">{t('departmentReview.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('departmentReview.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
